"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundMoney = roundMoney;
/** Round to 2 decimal places (currency cents). Avoids IEEE float display like 34859.840000000004. */
function roundMoney(value) {
    return Math.round((Number(value) || 0) * 100) / 100;
}
